import { pendingTask, begin, end } from 'react-redux-spinner'
import api from '../api'
import { handleApiError } from '../lib/helper'

function loadScheduleRequest() {
  return {
    type: 'FETCH_SCHEDULE_REQUEST',
    [pendingTask]: begin
  }
}

function loadScheduleSuccess(data) {
  return {
    type: 'FETCH_SCHEDULE_SUCCESS',
    payload: data,
    [pendingTask]: end
  }
}

function loadScheduleFailure(error) {
  return {
    type: 'FETCH_SCHEDULE_FAILURE',
    [pendingTask]: end
  }
}


export function loadSchedule(selectedProductKey, currentDate) {
  return dispatch => {
    dispatch(loadScheduleRequest());
    return api.initSchedule(selectedProductKey, currentDate)
      .then((res) => {
        dispatch(loadScheduleSuccess(res.data));
      })
      .catch(error => {
        dispatch(loadScheduleFailure(error));
        handleApiError(error, 'loadSchedule error');
      });
  }
}
